import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={20.827}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17331 14044"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#000}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974618661184">
        <path
          d="m8513 12897 567 73c1332-196 2138-1119 2405-2495l432 3c3 931-587 1635-1012 2074-1896 1958-5505 461-5510-2077l5763-4c-10 728-507 1307-852 1622-359 326-793 529-1299 585-602 66-431 41-494 219zm84-7739c344 108 4818 3055 5554 3513l1821 1190-14636 17c453-372 1230-838 1795-1187l3654-2355c628-388 1230-760 1812-1178zm8734 5143v-250c-593-521-8329-5311-8405-5469-53-942 125-3995-87-4563-555-86-516 118-510 646l-1 4015C8139 4748 365 9695 0 10010l25 406c925 256 4160-178 4732 113 5 5 464 3526 3909 3515 1138-3 2075-486 2655-1077 742-754 967-1141 1218-2486 769-45 1636-10 2416-10 656 0 1991 189 2376-170z"
          className="fil0"
        />
        <path
          d="M3217 9397c356-1 2416-1428 2885-1720l2428-1556c273-177 238-36 256-339-248-119-465 103-690 256-256 173-493 306-727 463L3447 9007c-218 132-244 93-230 390z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
